var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.33333C12 5.44799 12 4.50466 11.414 3.91933C10.8287 3.33333 9.88533 3.33333 8 3.33333H6C4.11467 3.33333 3.17133 3.33333 2.586 3.91933C2 4.50466 2 5.44799 2 7.33333V10.6667C2 12.552 2 13.4953 2.586 14.0807C3.17133 14.6667 4.11467 14.6667 6 14.6667H8C9.88533 14.6667 10.8287 14.6667 11.414 14.0807C12 13.4953 12 12.552 12 10.6667V7.33333Z",
    stroke: "#50429B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12 12.6667C12.5304 12.6667 13.0391 12.456 13.4142 12.0809C13.7893 11.7058 14 11.1971 14 10.6667V6.66667C14 4.15267 14 2.89533 13.2187 2.11467C12.438 1.33333 11.1807 1.33333 8.66667 1.33333H6C5.46957 1.33333 4.96086 1.54405 4.58579 1.91912C4.21071 2.29419 4 2.8029 4 3.33333",
    stroke: "#50429B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.cc5b890558d6de9b8b28ff1a8bd25da1.svg";
export { ForwardRef as ReactComponent };